import React, { useEffect, useState, Fragment } from 'react'
import { Card, Col, Container, Form, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { formato_monto, formatoTest, formatoTestUS, isValidParam, moneyPunto} from '../../../common/Formatos'

const AntecedentesEnvioRecobro = ({formik, setPorConvenioOld, setMirecobroNo, disabledMontoNeto, setNuevoNeto}) => {
  
  const data_encargado_cia = useSelector((state) => state.encargado_compania)
  const {cfg_form9, casoImplicado, liquidacionPerdida, requisitos} = data_encargado_cia
  const [seguro, setSeguro]=useState("")
  const [compania, setCompania]=useState("")
  const [siniestro, setSiniestro]=useState("")
  const [fechaSiniestro, setFechaSiniestro]=useState("")
  const [convenio, setConvenio]=useState(0)
  const [convenioOld, setConvenioOld]=useState(0)
  const[montoNeto,setMontoNeto]=useState(0)
  const[recobro,setRecobro]=useState(0)
  const[recobroNoFormato,setRecobroNoFormato]=useState(0)
  const[excepcion,setExcepcion]=useState("")
  const[observaciones,setObservaciones]=useState("")
  const[requisitosValida,setRequisitos]=useState("")

  const [miRecobro, setMiRecobro] = useState(0)
  const [miMontoNeto, setMiMontoNeto] = useState(0)
  const [miRecobroNoFormato, setMiRecobroNoFormato]=useState(0)//Este es el que mando en la data sin formato
  const [blur, setBlur] = useState(false);

  const dispatch = useDispatch();

useEffect(()=>{
  setPorConvenioOld(convenioOld)
  setMirecobroNo(recobroNoFormato)
},[convenioOld,recobroNoFormato])

useEffect(() => {
  setMiMontoNeto(casoImplicado && casoImplicado.length !== 'undefined' ? casoImplicado.casoImplicado[0]['MontoCosto'] : "")
  setMiRecobro(casoImplicado && casoImplicado.length !== 'undefined' ? formato_monto(casoImplicado.casoImplicado[0]['MontoRecobro']) : "")
  setRecobroNoFormato(casoImplicado && casoImplicado.length !== 'undefined' ? casoImplicado.casoImplicado[0]['MontoRecobro'] : "")
  
  let montoCosto = isValidParam(casoImplicado?.casoImplicado[0]['MontoCosto']) ? casoImplicado?.casoImplicado[0]['MontoCosto'] : 0;
  formik.setFieldValue('montoNeto', validateMontoMoneda(montoCosto, 'format'));

}, [casoImplicado]);

useEffect(()=>{
  setRequisitos(requisitos && requisitos.requisitos)
},[requisitos])
  
useEffect(()=>{
  setMontoNeto(liquidacionPerdida && liquidacionPerdida.length !== 'undefined'
  ? liquidacionPerdida.liquidacionPerdida['mtoSalvataje']!==null && liquidacionPerdida.liquidacionPerdida['mtoPago']!==null
    ? (parseInt(liquidacionPerdida.liquidacionPerdida['mtoPago']) - parseInt(liquidacionPerdida.liquidacionPerdida['mtoSalvataje'])) 
    :(liquidacionPerdida.liquidacionPerdida['mtoPago'])
  : 0)
},[liquidacionPerdida])

useEffect(()=>{
  setSeguro(casoImplicado && casoImplicado.length !== 'undefined'
  ? casoImplicado.casoImplicado[0]['IdSeguroImplicado']
  : "")
  setCompania(casoImplicado && casoImplicado.length !== 'undefined'
  ?casoImplicado.casoImplicado[0]['IdCiaImplicado']!==null?casoImplicado.casoImplicado[0]['IdCiaImplicado']:""
  : "")
  setSiniestro( casoImplicado && casoImplicado.length !== 'undefined'
  ? (casoImplicado.casoImplicado[0]['SiniestroIM']===null?"":casoImplicado.casoImplicado[0]['SiniestroIM'])
  : "")
  setFechaSiniestro(casoImplicado && casoImplicado.length !== 'undefined'
  ? (casoImplicado.casoImplicado[0]['FechaSiniestroIM']===null?"":casoImplicado.casoImplicado[0]['FechaSiniestroIM'].split("T")[0])
  : "")
  setConvenio(casoImplicado && casoImplicado.casoImplicado[0]['PorConvenido']!==null && casoImplicado.casoImplicado[0]['PorConvenido']!==undefined?casoImplicado.casoImplicado[0]['PorConvenido']:"" )
  setConvenioOld(convenio);
},[casoImplicado,liquidacionPerdida,montoNeto])

const restarFechas=(fechaInicio)=>{    
  const [dia, mes, ano]=fechaInicio.split("-")   
  const fechaFormat=[ano, mes,dia].join("-")     
  const tiempoTranscurrido = Date.now();
  const hoy = new Date(tiempoTranscurrido).getTime(); 
  var diff = hoy - new Date(fechaFormat).getTime();
  return parseInt(diff/(1000*60*60*24));
}

function validaConvenio(event){ 
  
  var e = event || window.event;
    var key = e.keyCode || e.which;
    if ( key === 110 || key === 190 ) {     
        
     return true;     
   } 
    
    if(key==8 || key===46 || key===37 ||key===39) { // backspace.
      return true;
    } else if(key>=48 && key<=57) { // is a number.
      return true;
    }else if(key>=96 && key<=105) { // is a number.
      return true;
    } 
    else{ // other keys.
      e.preventDefault();   
    } 
  // code is the decimal ASCII representation of the pressed key.
}
const validateMontoMoneda = (value, action) => {
  if (action === 'format') return formatoTest(value, true);
  else {
    if (Number(formik.values.moneda) === 30001) return formatoTest(value, false);
        else return formatoTest(value, true);
    }
}
const validateStateMonto = (value) => {
    if (Number(formik.values.moneda) === 30001) return formatoTestUS(value, false);
    else return formatoTestUS(value, true);
}
const handleFocusBlur = (action, type, value) => {
  if (action === "focus") {
      setBlur(false);
      if (type === "montoNeto") formik.setFieldValue([type], miMontoNeto);
      else formik.setFieldValue([type], validateStateMonto(miMontoNeto));
  } else {
      setBlur(true);
      if (type === "montoNeto") formik.setFieldValue([type], validateMontoMoneda(miMontoNeto, 'format'));
      else formik.setFieldValue([type], validateMontoMoneda(miMontoNeto, 'format'));
      setNuevoNeto(miMontoNeto);
  }
}
  return (
      <>
    
      <style type='text/css'>
      {`
        .convenio {
          width: 80px;      
        }
      `}
      </style>
    <Card className='mt-1 '>
      <Card.Header className='mt-0 mb-0' as='h6' style={{backgroundColor:"#4F517A", color:"#FFFFFF"}}>
        {cfg_form9 ? cfg_form9.cfg_form9['respuestarecobro-title-antecenvio'] : ""}
      </Card.Header>
      <Container>
        {cfg_form9 ? (
          <div>
          <Row className='mb-3'>
            <Col>
              <Form.Label  className='mt-3 mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }} >
                {cfg_form9 && cfg_form9.cfg_form9['respuestarecobro-lbl-estadorec']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3'>
                {casoImplicado && casoImplicado.length !== 'undefined' ? casoImplicado.casoImplicado[0]['EstadoImplicado'] : ""}
              </Form.Text>
            </Col>               
            <Col>
              <Form.Label  className='mt-3 mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                {cfg_form9 && cfg_form9.cfg_form9['respuestarecobro-cmb-cia']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3'>
                { casoImplicado && casoImplicado.length !== 'undefined' ? casoImplicado.casoImplicado[0]['CiaImplicado'] : ""}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label  className='mt-3 mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                {cfg_form9 && cfg_form9.cfg_form9['respuestarecobro-input-siniestroimpl']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3'>
                { casoImplicado && casoImplicado.length !== 'undefined' ? casoImplicado.casoImplicado[0]['SiniestroIM'] : ""}
            </Form.Text>                                  
            </Col>
            <Col>
              <Form.Label className='mt-3 mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }} >
                {cfg_form9 && cfg_form9.cfg_form9['respuestarecobro-input-fechasinimpl']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3'>
                { casoImplicado && casoImplicado.length !== 'undefined' ? casoImplicado.casoImplicado[0]['FechaSiniestroIMFormat'] : ""}
              </Form.Text>                  
            </Col>
            <Col  >
              <Form.Label  className='mt-3 mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }} >
                {cfg_form9 && cfg_form9.cfg_form9['respuestarecobro-cmb-motivoexcep']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3'>
                { casoImplicado && casoImplicado.length !== 'undefined' ? casoImplicado.casoImplicado[0]['GlosaMotivoExcepcion'] : ""}
              </Form.Text>
            </Col>
          </Row>
          <Row>              
            <Col>
              <Form.Label className='mb-0  mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                {cfg_form9 && cfg_form9.cfg_form9 ['respuestarecobro-cmb-moneda']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3'>
                {casoImplicado && casoImplicado.length !== 'undefined' ? casoImplicado.casoImplicado[0]['GlosaMonedaLocal'] : ""}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label className=' mb-0  mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                {cfg_form9 && cfg_form9.cfg_form9['respuestarecobro-input-mtoneto']}
              </Form.Label>
              <br />
              <Form.Control
                  aria-label='Default select example'                    
                  onKeyDown={e=>{
                    //validaConvenio(e)
                  }}                    
                  //type="number"
                  onChange={e=>{                    
                      formik.handleChange(e)
                      setMiMontoNeto(e.target.value)
                      setMiRecobro(casoImplicado?.casoImplicado[0]['CodMonedaLocal'] == 30001 ? formato_monto(Math.round(e.target.value*convenio/100)):formato_monto(parseFloat(e.target.value*convenio/100).toFixed(2)))                        
                      setRecobroNoFormato(casoImplicado?.casoImplicado[0]['CodMonedaLocal'] == 30001 ? Math.round(e.target.value*convenio/100):parseFloat(e.target.value*convenio/100).toFixed(2))                        
                  }}
                  onBlur={e=>{
                    formik.handleBlur(e);
                    if (miMontoNeto !=="" && miMontoNeto !== null && miMontoNeto !== undefined) {              
                      if (miMontoNeto?.toString().includes(".")) setMiMontoNeto(parseFloat(miMontoNeto).toFixed(2))
                      else setMiMontoNeto(miMontoNeto)
                    }
                    handleFocusBlur('blur', 'montoNeto', e.target.value)              
                  }}   
                  onFocus={e => handleFocusBlur('focus', 'montoNeto', e.target.value)}
                  onKeyPress={(e) => moneyPunto(e, casoImplicado?.casoImplicado[0]['CodMonedaLocal'] != 30001)}
                  name='montoNeto'
                  value={formik.values.montoNeto}
                  error={formik.errors.montoNeto}        
                  disabled={disabledMontoNeto}  
                ></Form.Control>              
                {formik.errors.montoNeto ? (<Form.Text variant="danger" style={{color:"red"}} >{formik.errors.montoNeto}</Form.Text>) :""}
              {/*<Form.Text className='mb-3'>
              {formato_monto(miMontoNeto)}
              </Form.Text>*/}
            </Col>            
            <Col>
              <Form.Label className='mb-0  mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                {cfg_form9 && cfg_form9.cfg_form9['respuestarecobro-input-porcconvenio']}
              </Form.Label>
              <Form.Control
                  className='convenio'                   
                  aria-label='Default select example'                    
                  onKeyDown={e=>validaConvenio(e)}                    
                  type="number"
                  onChange={e=>{                    
                      formik.handleChange(e)
                      setConvenio(e.target.value)
                      setMiRecobro(casoImplicado && (casoImplicado.casoImplicado[0]['GlosaMonedaLocal'])==='Pesos CLP'?formato_monto(Math.round(miMontoNeto*e.target.value/100)):formato_monto(parseFloat(miMontoNeto*e.target.value/100).toFixed(2)))                        
                      setRecobroNoFormato(casoImplicado &&(casoImplicado.casoImplicado[0]['GlosaMonedaLocal'])==='Pesos CLP'?Math.round(miMontoNeto*e.target.value/100):parseFloat(miMontoNeto*e.target.value/100).toFixed(2))                        
                  }}
                  onBlur={()=>{
                      if (convenio!=="" && convenio!==null && convenio!==undefined) {                       
                      if(convenio?.toString().includes(".")) setConvenio(parseFloat(convenio).toFixed(2))
                      else setConvenio(convenio)
                      }                     
                  }}   
                  name='porcConvenio'
                  value={formik.values.porcConvenio = convenio}
                  error={formik.errors.porcConvenio}                          
                ></Form.Control>              
                {formik.errors.porcConvenio ? (<Form.Text variant="danger" style={{color:"red"}} >{formik.errors.porcConvenio}</Form.Text>) :""}
            </Col>
            <Col>
              <Form.Label  className='mb-0  mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }} >
                {cfg_form9 && cfg_form9.cfg_form9['respuestarecobro-input-mtorecobro']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3'>
                {miRecobro}
              </Form.Text>              
            </Col>             
            <Col>
              <Form.Label className='mt-2 mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                {cfg_form9 && cfg_form9.cfg_form9['respuestarecobro-input-obsmotivo']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3'>
              {casoImplicado && casoImplicado.length !== 'undefined' ? casoImplicado.casoImplicado[0]['ObsExcepcion'] : ""}
              </Form.Text>
            </Col>
          </Row>
          <Row >
            <Col md="4" ></Col>
          </Row>
          <Row className="mb-3" >
            <Col >
              <Form.Label className='mt-3 mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }} >
                  {cfg_form9 && cfg_form9.cfg_form9['respuestarecobro-lbl-fechaenviocarta']}
                </Form.Label>
                <br />
                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>               
                {casoImplicado && casoImplicado.length !== 'undefined' ? casoImplicado.casoImplicado[0]['FechaEnvioCartaCobroFormat']: ""}
              </Form.Text>
            </Col>
            <Col >
              <Form.Label className='mt-3 mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                {cfg_form9 && cfg_form9.cfg_form9['respuestarecobro-lbl-destinatario']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {casoImplicado && casoImplicado.length !== 'undefined' ? casoImplicado.casoImplicado[0]['DestinatarioCIA']: ""}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label className='mt-3 mb-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
              </Form.Label>
              <br />
              <Form.Text className='mb-3 mt-3' style={{ fontSize: '14px', marginLeft:'50px' }}>               
                {casoImplicado && casoImplicado.length !== 'undefined'? casoImplicado.casoImplicado[0]['EmailDestinatarioCIA']: ""}
               </Form.Text>              
            </Col>
            <Col></Col>
            <Col></Col>        
          </Row>                      
          </div>
        ) : ""}
      </Container>
    </Card>
    </>
  )
}
export default AntecedentesEnvioRecobro


